export const RoutePostStores = "/stores";

export interface PayloadPostStores {
  code: string;
}
